// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import jQuery from 'jquery'
import axios from 'axios'
import lodash from 'lodash'
import moment from 'moment'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'

import App from './App'
import router from './router'
import store from './store'
import api_routes from '@/api/api_routes'

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBXXzerxH5r2GahWzWegy30Elh_K8z__V8',
        v: '3.27',
        libraries: 'places', //// If you need to use place input
    },
    installComponents: true,
});

import 'vue-event-calendar/dist/style.css'
import vueEventCalendar from 'vue-event-calendar'
Vue.use(vueEventCalendar, {locale: 'en'}) //locale can be 'zh' , 'en' , 'es', 'pt-br', 'ja'


// Auth
import config from './.env';
window.config = config;
import auth from './libs/authService';
window.$auth = auth;

// globalize packages to use from any components
global.Event = new Vue()
global.jQuery = global.$ = jQuery
global.lodash = global._ = lodash
global.axios = axios
global.moment = moment
global.Vue = Vue
global.api_routes = api_routes

// Error handling class
// Usable in all components
global.Errors = class Errors {
    constructor() {
        this.errors = {}
    }

    get(field) {
        if (this.errors[field]) {
            return this.errors[field][0]
        }
    }

    has(field) {
        return !! this.errors[field]
    }

    record(errors) {
        this.errors = errors
    }

    clear(field) {
        if (field) {
            this.errors[field] = null
        } else {
            this.errors = {}
        }
    }
}

global.methods = {
    dateFormat(date, format) {
        let dateString = (date === undefined) ? null : date
        let dateObj = moment(dateString)

        return dateObj.isValid() ? dateObj.format(format) : null
    },

    setDefaultBearer() {
        axios.defaults.headers.common = this.getReqHeaders()
    },

    getReqHeaders() {
        return {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('id_token')
        };
    },

    isValidURL(url) {
        return url.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g);
    },

    beforeUpload(ctx, file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        let isImage = false;
        if (isJPG) isImage = true;
        if (isPNG) isImage = true;

        if (!isImage) {
            ctx.$message.error('Image must be JPG or PNG format!');
        }

        if (!isLt2M) {
            ctx.$message.error('Image size can not exceed 2MB!');
        }

        return isImage && isLt2M;
    },

    hasPermission(data, permission) {
        if (data) {
            if (data.superman) {
                return true;
            }

            return data.permissions.indexOf(permission) != -1;
        }

        return false;
    }
}

// DATE FORMAT FILTER
Vue.filter('dateFormat', (date, format) => {
    return methods.dateFormat(date, format);
});

// DEFAULT HEADERS FOR AXIOS REQUEST
methods.setDefaultBearer();

// ElementUI Init
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale })
Vue.use(VueI18n)

// Translations
import { messages } from './translations'
const i18n = new VueI18n({
    locale: 'en', // set locale
    messages,
    silentTranslationWarn: true
});

Vue.config.productionTip = false

// external JS and stylesheet files
require('./_resources')

// global mixins
let mixin = {
    methods: {
        responsiveDialogSize(size = 'small') {
            let defaultSize = size;
            if (window.innerWidth < 481)
                defaultSize = 'full';

            return defaultSize;
        },

        isResponsive(width) {
            if (window.innerWidth <= width) return true;
            return false;
        },

        hasPermission(data, permission) {
            if (data) {
                if (data.superman) {
                    return true;
                }
                return data.permissions.indexOf(permission) != -1;
            }
            return false;
        },

        buildRoute(name, isGlobal = false) {
            return isGlobal ? 'entityGlobal.'+name : name;
        }
    }
}
Vue.mixin(mixin);

router.beforeEach((to, from, next) => {
    Event.$emit('startLoading');

    $(window).scrollTop(0);

    if (to.meta.requiresAuth && !$auth.checkAuth()) {
        localStorage.setItem('redirectUrl', to.fullPath);

        if (to.params.entity_id) {
            localStorage.setItem('communityId', to.params.entity_id);
        }

        next({
            name: 'login',
            query: { redirect: to.fullPath }
        })
    } else {
        if (to.name === 'login' && $auth.checkAuth()) {
            next({ name: 'dashboard' })
        }

        next();
    }
});

require('./configs/chart-js-config');

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    mixins: [mixin],
    store,
    i18n,
    template: '<App/>',
    components: {App},
})



// WEBPACK FOOTER //
// ./src/main.js